import { http } from "../index";
import Config from "../config/config";
import _ from "lodash";

/*const MainPageBanners = _.memoize((platform = "web") => {
  return http.get({
    url: Config.Banners.MainPage.replace("{platform}", platform),
  });
});
const PokerPageBanners = (platform = "new_m") => {
  return http.get({
    url: Config.Banners.PokerPage.replace("{platform}", platform),
  });
};*/
const Get = ({page, platform}) => {
  return http.get({
    url: Config.Banners.replace("{page}", page).replace("{platform}", platform),
  });
};
export default {
  Get
};
